/**
* @summary - License Parent Page
* @author Yuvasri S
* @since 2024-12-17
*/
import React, { useState, useRef, useEffect } from "react";
import { Box, Grid, Button } from "@mui/material";
import LicenseCertificateForm from "./LicenseCertificateForm";
import AssetSubFormGrid from "./AssetSubFormGrid";
import ContractorSubFormGrid from "./ContractorSubFormGrid";
import EmployeeSubFormGrid from "./EmployeeSubFormGrid";
import { useLocation, useNavigate } from "react-router-dom";
import CustomDialog from "../commoncomponents/CustomDialog";
import LicenseAttachments from "./LicenseAttachments";

const LicenseCertificateCreate = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const editMode = location?.state?.editmode;
    const viewMode = location?.state?.viewmode;
    const licenseCreateRef = useRef(null);
    const licenseAttachmentRef = useRef(null);
    const licenseSubFormGridRef = useRef(null);

    const [selectedLicenseCategory, setSelectedLicenseCategory] = useState(
        editMode || viewMode ? location?.state?.categoryName : null
    );

    const [selectedService, setSelectedService] = useState(editMode || viewMode ? location?.state?.service : null);

    const [dialogContent, setDialogContent] = useState("");
    const [openDialog, setOpenDialog] = useState(false);
    const [unsavedChangesDialog, setUnsavedChangesDialog] = useState(false);
    const [rowLength, setRowLength] = useState(0);
    const [buttondisable,setButtondisable] = useState(false);

    const handleLicenseCategoryChange = (category) => {
        if (!editMode && !viewMode) {
            if (category && category.value !== undefined) {
                setSelectedLicenseCategory(category.value);
            } else {
                setSelectedLicenseCategory(null); // Set to null or handle as needed
            }
        }
    };

    const handleServiceChange = (service) => {
        if (!editMode && !viewMode) {
            setSelectedService(service.value);
        }
    };


    useEffect(() => {
        if (editMode && location?.state?.categoryName) {
            setSelectedLicenseCategory(location?.state?.categoryName);
        }
    }, [editMode, viewMode, location?.state?.categoryName]);

    const handleSave = async () => {
        let headerId;
        try {
            let isEditFormSaved = false;
            let isSubFormSaved = false;
          
            if (editMode) {
             
                const attachmentvalidation = await licenseAttachmentRef.current.rowlength;
              //  console.log(licenseAttachmentRef.current.rowlength, "rowlengthrowlength");
                if (licenseCreateRef.current.hospital === "Hospital" ? licenseCreateRef.current : licenseCreateRef.current && rowLength > 0 && attachmentvalidation === false) {

                    const formResponse = await licenseCreateRef.current.handleSubmit();
                    console.log(formResponse,"formResponse");
                    await licenseAttachmentRef.current.handleSaveClick(formResponse.id);
                    await licenseAttachmentRef.current.fetchFiles(formResponse.id);
                    if (formResponse && formResponse.id) {
                        headerId = formResponse.id;
                        console.log(licenseSubFormGridRef.current,"licenseSubFormGridRef.current");
                        console.log(headerId,"headerId");
                        if (headerId) {
                            console.log("inside headerid");
                            await licenseSubFormGridRef.current.handleSubFormSubmit(headerId);
                            await licenseAttachmentRef.current.handleSaveClick(headerId);
                            await licenseAttachmentRef.current.fetchFiles(headerId);
                           
                        }
                        setButtondisable(true);
                        setDialogContent("Data updated successfully.");
                        setOpenDialog(true);
                    } else if (formResponse?.status === 400) {
                        setDialogContent(formResponse.response?.data?.detail || "License No Already Exists.");
                        setOpenDialog(true);
                        return; // Exit on error
                    } else {
                        throw new Error("Form submission failed or returned undefined response");
                    }
                }

            } else {

                const validation = await licenseCreateRef.current.validateFields();
                const attachmentvalidation = await licenseAttachmentRef.current.rowlength;
                console.log(licenseAttachmentRef.current.rowlength, "rowlengthrowlength");
                if (validation === true && attachmentvalidation === false) {
                    if (licenseCreateRef.current.hospital.value === "Hospital" ? licenseCreateRef.current : licenseCreateRef.current && rowLength > 0 ) {
                        const formResponse = await licenseCreateRef.current.handleSubmit();
                        await licenseAttachmentRef.current.handleSaveClick(formResponse.id);
                        await licenseAttachmentRef.current.fetchFiles(formResponse.id);
                        if (formResponse && formResponse.id) {
                            headerId = formResponse.id;
                            isEditFormSaved = true;
                        } else if (formResponse?.status === 400) {
                            setDialogContent(formResponse.response?.data?.detail || "License No already exists.");
                            setOpenDialog(true);
                            return; // Exit on error
                        } else {
                            throw new Error("Form submission failed or returned undefined response");
                        }
                    }
                    if (licenseCreateRef.current.hospital.value !== "Hospital") {
                        if (licenseSubFormGridRef.current && headerId) {
                            const subForm = await licenseSubFormGridRef.current.handleSubFormSubmit(headerId);
                            await licenseAttachmentRef.current.handleSaveClick(headerId);
                            await licenseAttachmentRef.current.fetchFiles(headerId);
                            if (subForm[0]?.id) {
                                isSubFormSaved = true;
                            } else {
                                throw new Error("Grid submission failed or returned undefined response");
                            }
                        }
                    }
                    else {
                        isSubFormSaved = true;
                    }

                    if (isEditFormSaved && isSubFormSaved) {
                        setButtondisable(true);
                        setDialogContent("Data saved successfully.");
                        setOpenDialog(true);
                    }
                }
            }

        } catch (error) {
            console.error(error); // Handle error as needed
        }
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleCancel = () => {
        if (viewMode) {
            navigate(-1, { replace: true });
            return;
        }

        const hasChanges = licenseCreateRef.current?.hasUnsavedChanges?.();
        if (!hasChanges) {
            navigate(-1, { replace: true });
        } else {
            setUnsavedChangesDialog(true);
        }
    };

    const confirmCancel = () => {
        setUnsavedChangesDialog(false);
        navigate(-1, { replace: true });
    };

    const cancelCloseDialog = () => {
        setUnsavedChangesDialog(false);
    };

    

    const renderSubformGrid = () => {
      
        switch (selectedLicenseCategory) {
            case "Asset":
                return <AssetSubFormGrid ref={licenseSubFormGridRef} service={selectedService} licenseCategory={selectedLicenseCategory} setRowLength={(item) => setRowLength(item)} />;
            case "Employee":
                return <EmployeeSubFormGrid ref={licenseSubFormGridRef} service={selectedService} licenseCategory={selectedLicenseCategory} setRowLength={(item) => setRowLength(item)} />;
            case "Vendor":
                return <ContractorSubFormGrid ref={licenseSubFormGridRef} service={selectedService} licenseCategory={selectedLicenseCategory} setRowLength={(item) => setRowLength(item)} />;
            default:
                return null;
        }
    };
    
    return (
        <>
            <Box mb={2} />
            <LicenseCertificateForm ref={licenseCreateRef} onLicenseCategoryChange={handleLicenseCategoryChange} onServiceChange={handleServiceChange} />
            <Box mb={2} />
            {renderSubformGrid()}
            <LicenseAttachments ref={licenseAttachmentRef}   />
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                {!viewMode && (
                    <Button
                        variant="contained"
                        color="primary"
                        sx={{ m: 1 }}
                        onClick={handleSave}
                        disabled={buttondisable}
                    >
                        {editMode ? "Update" : "Save"}
                    </Button>
                )}

                <Button variant="outlined" sx={{ m: 1 }} onClick={handleCancel}>
                    Back
                </Button>
            </Box>
            <CustomDialog
                open={openDialog}
                onClose={handleCloseDialog}
                content={dialogContent}
                confirmBtn="OK"
                onConfirm={handleCloseDialog}
            />
            <CustomDialog
                open={unsavedChangesDialog}
                onClose={cancelCloseDialog}
                content="Record(s) not Saved/Updated. Do you want to continue?"
                confirmBtn="Yes"
                cancelBtn="No"
                onConfirm={confirmCancel}
                onCancel={cancelCloseDialog}
            />
        </>
    );
};

export default LicenseCertificateCreate;
